const AGENSTS = {
  AGENT_LIST_TITLE: "همکاران",
  SEARCH_IN_AGENTS: "جستجو در بین همکاران",
};

export default AGENSTS;
